<template>
	<header class="header">
		<div
			class="header_wrapper"
			:style="'background-image:url(' + fetchedData.top_cover_image_default.src + ')'"
		>
			<top-menu-new :fetched-data="fetchedData" />
			<div class="container">
				<div class="header_main">
					<img v-if="showOwerlay" src="/research/Group-27.svg" class="frame f1">
					<img v-if="showOwerlay" src="/research/icon.svg" class="frame f2">

					<div class="row">
						<div class="col-10 col-md-10 col-lg-11">
							<div class="title_block">
								<div v-if="fetchedData.tagline !== null" class="tagline">
									{{ fetchedData.tagline }}
								</div>
								<h1>{{ fetchedData.title }}</h1>
								<div class="title">
									<div v-if="fetchedData.intro !==null" class="subtitle">
										{{ fetchedData.intro }}
									</div>
									<div v-if="fetchedData.subtitle !== null">
										{{ fetchedData.subtitle }}
									</div>
									<div v-if="fetchedData.description !== null" class="subtitle">
										{{ fetchedData.description }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="event_menu">
			<div class="container">
				<div class="swiper_menu">
					<div v-swiper:menuSwiper="options">
						<div class="swiper-wrapper">
							<div v-for="(block, index) in fetchedData.blocks" :key="index" class="swiper-slide">
								<a
									v-if="block.type ==='panel-navigation'"
									v-scroll-to="'#' + block.type + block.id"
									href="#"
								>{{ block.content.block_title.ru }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>

	<!-- <header class="header">
        <div class="header_wrapper">
            <issue-menu></issue-menu>
            <div class="container">
                <div class="header_main">
                    <img src="/research/Group-27.svg" class="frame f1">
					<img src="/research/icon.svg" class="frame f2">
					<div class="row">
						<div class="col-12 col-lg-11">
                            <div class="title_block">
                                <div class="subtitle">Результаты исследования</div>
								<h1>Инвестиционные предпочтения владельцев капитала</h1>
                                <div class="title">Центр управления благосостоянием и филантропии СКОЛКОВО</div>
							</div>
						</div>
					</div>

                </div>
            </div>
        </div>
    </header> -->
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import TopMenuNew from '~/components/layouts/_partials/TopMenuNew.vue';
import IssueMenu from '~/components/layouts/_partials/IssueMenu.vue';

export default {
	name: 'ResearchHeader',
	components: {
		TopMenuNew,
		IssueMenu,
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	props: {

		fetchedData: { type: Object, default: null, required: true },
		showOwerlay: { type: Boolean, default: true },
	},
	data() {
		return {
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				cssMode: true,
				loop: false,
			},
		};
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/event-menu";
	// @import "~/assets/styles/components/dev/research-header";
	@import "~/assets/styles/components/home/center_research-header";

	.frame {
		position: absolute;
		display: block;
		&.f1{
			width: 30.875rem;
			right: 6rem;
			bottom: 2rem;

			// @include media-breakpoint-up(sm) {
			// 	width: 30.875rem;
			// 	right: 15rem;
			// 	bottom: 7rem;
			// }
			// @include media-breakpoint-up(xs) {
			// 	width: 12.88rem;
			// 	right: 5rem;
			// 	bottom: 6rem;
			// }
		}
		&.f2{
			// width: 30.875rem;
			// right: -5rem;
			// bottom: -7rem;

			// @include media-breakpoint-up(xs) {
			// 	width: 15.88rem;
			// 	right: -8rem;
			// 	bottom: -5rem;
			// }

				width: 23.88rem;
				right: -12rem;
				bottom: -12rem;
			@include media-breakpoint-up(sm) {
			}
		}
	}

</style>
